export default {
  install: app => {
    const files = require.context('./base', true, /\.vue$/i)
    files.keys().map(key => {
      const name = key.replace('./', '').split('.')[0]
      return app.component(name, files(key).default)
    })
  }
}
